import { render, staticRenderFns } from "./ProcessFBMReportTableAdmin.vue?vue&type=template&id=fb5d78c8&scoped=true"
import script from "./ProcessFBMReportTableAdmin.vue?vue&type=script&lang=js"
export * from "./ProcessFBMReportTableAdmin.vue?vue&type=script&lang=js"
import style0 from "./ProcessFBMReportTableAdmin.vue?vue&type=style&index=0&id=fb5d78c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5d78c8",
  null
  
)

export default component.exports